import React from "react";
import { brands, refcomLogo } from "../data/mockData";

// Auto-scrolling brand marquee. Duplicates the list so the loop is seamless.
const BrandsMarquee = () => {
  const loop = [...brands, ...brands, ...brands];

  return (
    <section
      aria-labelledby="brands-heading"
      className="relative bg-white border-y border-gray-100 py-10 sm:py-12 overflow-hidden"
      data-testid="brands-marquee"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-6 sm:mb-8 text-center">
        <p
          id="brands-heading"
          className="text-brand-mint-dark text-[10px] sm:text-xs font-bold uppercase tracking-[0.28em]"
        >
          Approved Brands We Install
        </p>
      </div>

      {/* Marquee track */}
      <div className="relative">
        {/* Edge fades */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-y-0 left-0 w-20 sm:w-32 bg-gradient-to-r from-white to-transparent z-10"
        />
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-y-0 right-0 w-20 sm:w-32 bg-gradient-to-l from-white to-transparent z-10"
        />

        <div className="flex w-max items-center gap-10 sm:gap-16 animate-brand-scroll hover:[animation-play-state:paused]">
          {loop.map((brand, i) => (
            <div
              key={`${brand.name}-${i}`}
              className="flex-shrink-0 flex items-center justify-center h-16 sm:h-20 w-36 sm:w-48"
              data-testid={`brand-${brand.name.toLowerCase().replace(/\s+/g, "-")}-${i}`}
            >
              <img
                src={brand.logo}
                alt={brand.name}
                loading="lazy"
                decoding="async"
                className="max-h-full max-w-full w-auto h-auto object-contain opacity-80 hover:opacity-100 transition-opacity duration-200"
                style={{ mixBlendMode: "multiply" }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Governing body — REFCOM (kept separate from the brand rotation) */}
      <div
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10 sm:mt-12 flex flex-col items-center"
        data-testid="refcom-credential"
      >
        <div className="h-px w-16 bg-gray-200 mb-8" aria-hidden="true" />
        <img
          src={refcomLogo}
          alt="A member of REFCOM"
          loading="lazy"
          decoding="async"
          className="h-20 sm:h-24 w-auto object-contain"
          style={{ mixBlendMode: "multiply" }}
        />
        <p className="mt-4 text-gray-500 text-[10px] sm:text-xs font-bold uppercase tracking-[0.28em]">
          A Member of REFCOM
        </p>
      </div>
    </section>
  );
};

export default BrandsMarquee;
